import SidebarMenu from "react-bootstrap-sidebar-menu";
import { Link } from "react-router-dom";
import React from "react";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import KeyboardReturnOutlinedIcon from "@mui/icons-material/KeyboardReturnOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import { ReactComponent as PictoPlv } from "../assets/svg/plv.svg";
//import { ReactComponent as PictoChallenge } from "../assets/svg/challenge.svg";

import { store } from "../reducer/Store";
const SidebarAdmin = () => {
  const { dispatch } = React.useContext(store);

  return (
    <SidebarMenu
      variant="light"
      bg="white"
      expand="sm"
      className="sidebar-admin"
    >
      <SidebarMenu.Collapse>
        <SidebarMenu.Header>
          <Link to="/client">
            <SidebarMenu.Brand>
              <img
                src="/assets/img/logo/logo.svg"
                alt="Pierre Fabre"
                width="200"
                height="35"
              />
            </SidebarMenu.Brand>
          </Link>
          <SidebarMenu.Toggle />
        </SidebarMenu.Header>
        <SidebarMenu.Body>
          <SidebarMenu.Nav>
            <h2 className="text-uppercase blue text-center pt-3">
              Administration
            </h2>
            <hr />
            {parseInt(localStorage.getItem("user_role")) === 1 ||
            parseInt(localStorage.getItem("user_role")) === 2 ? (
              <>
                <SidebarMenu.Nav.Link
                  as={Link}
                  to="/admin/rapport-visuel"
                  eventKey="menu_visuel"
                  onClick={() => {
                    // avoid display content before its ready to render in Visuel Rapport
                    dispatch({ type: "SET_LOADER", payload: true });
                  }}
                >
                  <SidebarMenu.Nav.Icon>
                    <PictureAsPdfOutlinedIcon />
                  </SidebarMenu.Nav.Icon>
                  <SidebarMenu.Nav.Title>Visuel Rapport</SidebarMenu.Nav.Title>
                </SidebarMenu.Nav.Link>
                <SidebarMenu.Nav.Link
                  as={Link}
                  to="/admin/clients"
                  eventKey="menu_admin_clients"
                >
                  <SidebarMenu.Nav.Icon>
                    <PersonOutlineOutlinedIcon />
                  </SidebarMenu.Nav.Icon>
                  <SidebarMenu.Nav.Title>Clients</SidebarMenu.Nav.Title>
                </SidebarMenu.Nav.Link>
                <SidebarMenu.Nav.Link
                  as={Link}
                  to="/admin/operations"
                  eventKey="menu_admin_operations"
                >
                  <SidebarMenu.Nav.Icon>
                    <LocalOfferOutlinedIcon />
                  </SidebarMenu.Nav.Icon>
                  <SidebarMenu.Nav.Title>Opérations</SidebarMenu.Nav.Title>
                </SidebarMenu.Nav.Link>
                {/* <JC */}
                <SidebarMenu.Nav.Link
                  as={Link}
                  to="/admin/labels-operations"
                  eventKey="menu_admin_labels_operations"
                >
                  <SidebarMenu.Nav.Icon>
                    <LocalOfferOutlinedIcon />
                  </SidebarMenu.Nav.Icon>
                  <SidebarMenu.Nav.Title>Labels opérations</SidebarMenu.Nav.Title>
                </SidebarMenu.Nav.Link>
                <SidebarMenu.Nav.Link
                  as={Link}
                  to="/admin/preconisations"
                  eventKey="menu_admin_preconisations"
                >
                  <SidebarMenu.Nav.Icon>
                    <ImageOutlinedIcon />
                  </SidebarMenu.Nav.Icon>
                  <SidebarMenu.Nav.Title>Préconisations</SidebarMenu.Nav.Title>
                </SidebarMenu.Nav.Link>
                  {/* <JC */}
                  <SidebarMenu.Nav.Link
                  as={Link}
                  to="/admin/imports-manuels"
                  eventKey="menu_admin_imports_manuels"
                >
                  <SidebarMenu.Nav.Icon>
                    <ImageOutlinedIcon />
                  </SidebarMenu.Nav.Icon>
                  <SidebarMenu.Nav.Title>Imports manuels</SidebarMenu.Nav.Title>
                </SidebarMenu.Nav.Link>
                  {/* JC> */}
                {/*
                <SidebarMenu.Nav.Link
                  as={Link}
                  to="/admin/challenges"
                  eventKey="menu_admin_challenges"
                >
                  <SidebarMenu.Nav.Icon>
                    <PictoChallenge
                      className="sidebarIcon"
                      alt="Challenge"
                      style={{ width: 24, height: 24 }}
                    />
                  </SidebarMenu.Nav.Icon>
                  <SidebarMenu.Nav.Title>Challenges</SidebarMenu.Nav.Title>
                </SidebarMenu.Nav.Link>
                */}
                <hr />
              </>
            ) : (
              ""
            )}

            {parseInt(localStorage.getItem("user_role")) === 1 ||
            parseInt(localStorage.getItem("user_role")) === 2 ? (
              <>
                <SidebarMenu.Nav.Link
                  as={Link}
                  to="/admin/utilisateurs"
                  eventKey="menu_utilisateurs"
                >
                  <SidebarMenu.Nav.Icon>
                    <PersonOutlineOutlinedIcon />
                  </SidebarMenu.Nav.Icon>
                  <SidebarMenu.Nav.Title>Utilisateurs</SidebarMenu.Nav.Title>
                </SidebarMenu.Nav.Link>
                <SidebarMenu.Nav.Link
                  as={Link}
                  to="/admin/annees"
                  eventKey="menu_annees"
                >
                  <SidebarMenu.Nav.Icon>
                    <CalendarMonthOutlinedIcon />
                  </SidebarMenu.Nav.Icon>
                  <SidebarMenu.Nav.Title>Années</SidebarMenu.Nav.Title>
                </SidebarMenu.Nav.Link>
                {/*
                <SidebarMenu.Nav.Link
                  as={Link}
                  to="/admin/plv"
                  eventKey="menu_plv"
                >
                  <SidebarMenu.Nav.Icon>
                    <PictoPlv
                      className="sidebarIcon"
                      alt="PLV"
                      style={{ width: 24, height: 24 }}
                    />
                  </SidebarMenu.Nav.Icon>
                  <SidebarMenu.Nav.Title>PLV</SidebarMenu.Nav.Title>
                </SidebarMenu.Nav.Link>
                <SidebarMenu.Nav.Link
                  as={Link}
                  to="/admin/communications"
                  eventKey="menu_communication"
                >
                  <SidebarMenu.Nav.Icon>
                    <CampaignOutlinedIcon />
                  </SidebarMenu.Nav.Icon>
                  <SidebarMenu.Nav.Title>
                    Outils communication
                  </SidebarMenu.Nav.Title>
                </SidebarMenu.Nav.Link>
                
                <SidebarMenu.Nav.Link
                  as={Link}
                  to="/admin/prestataires"
                  eventKey="menu_prestataires"
                >
                  <SidebarMenu.Nav.Icon>
                    <AssignmentIndOutlinedIcon />
                  </SidebarMenu.Nav.Icon>
                  <SidebarMenu.Nav.Title>Prestataires</SidebarMenu.Nav.Title>
                </SidebarMenu.Nav.Link>
                */}
              </>
            ) : (
              ""
            )}
            <hr />
            <SidebarMenu.Nav.Link as={Link} to="/client">
              <SidebarMenu.Nav.Icon>
                <KeyboardReturnOutlinedIcon />
              </SidebarMenu.Nav.Icon>
              <SidebarMenu.Nav.Title>Retour vers Trade</SidebarMenu.Nav.Title>
            </SidebarMenu.Nav.Link>
          </SidebarMenu.Nav>
        </SidebarMenu.Body>
      </SidebarMenu.Collapse>
    </SidebarMenu>
  );
};

export default SidebarAdmin;
